// extracted by mini-css-extract-plugin
export default {"buttonEdit":"styles_buttonEdit__FCJPp"};